import {
  computed,
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AmbitoRef, isInAmbitoStruttura, UserProvider } from '../services';

@Directive({
  selector: '[libInAmbito]',
})
export class InAmbitoDirective {
  /**
   * Contesto and modulo of the item to check against the selected struttura
   */
  readonly libInAmbito = input<AmbitoRef | null>(null);

  /**
   * Template rendered when the item is in the ambito
   */
  private readonly templateRef = inject(TemplateRef);

  /**
   * Container where the template is rendered
   */
  private readonly viewContainer = inject(ViewContainerRef);

  /**
   * Source of the selected struttura
   */
  private readonly userProvider = inject(UserProvider);

  /**
   * Struttura currently selected by the user
   */
  private readonly selectedStruttura = toSignal(
    this.userProvider.selectedStruttura$,
    { initialValue: this.userProvider.currentStruttura },
  );

  /**
   * Whether the item belongs to the ambito of the selected struttura
   */
  private readonly inAmbito = computed(() =>
    isInAmbitoStruttura(this.libInAmbito(), this.selectedStruttura()),
  );

  constructor() {
    effect(() => {
      this.viewContainer.clear();
      if (this.inAmbito()) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
